export const initialStates = {
  transcriptText: '',
  currentSet: 0,
  currentTimeLeft: 0,
  stopSend: true,
  showReset: false,
  holdingCounter: 0,
  openSettingModel: false,
  hideText: false,
  cameraIsActive: false,
  // Flips true once getUserMedia has actually resolved or failed for this
  // mount — distinct from cameraIsActive, whose initial value is seeded from
  // a possibly-stale localStorage read (see exercise/index.jsx). The socket's
  // config message waits on this instead, so it reports the real device state
  // rather than a leftover value from a previous session.
  cameraCheckSettled: false,
  // True from the moment a live stream is detected as lost until the reacquire
  // for it resolves (or fails). The socket must not open — or reopen — while
  // this is true: the config message is the only place `cameraAvailable` can be
  // reported, and one sent mid-reacquire reports a camera the session does have.
  cameraReacquiring: false,
  showPost: false,
  expireTime: false,
  fullResetTime: 0,
  isCameraTranslated: false,
  isCConfigure: false,
  time: 0,
  toggleMirror: false,
  recordingDate: 0,
  frontendFps: null,
  mediaSourceType: 'camera',
  uploadedVideoUrl: '',
  preStartCountdown: 3,
  isPreStartCountdownComplete: false,
  isRecordingActive: false,
  videoRotation: 0,
  videoReady: false,
  introResult: false,
  drawOnImage: false,
  mediaPipeEnabled: true,
  // The mode in effect for the current exercise, restated by the backend on
  // every frame as `execution_mode`. Motion capture until it says otherwise.
  executionMode: 'MOTION_CAPTURE',
};
